import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=49c6a0ae&scoped=true"
import script from "./Mapping.vue?vue&type=script&lang=js"
export * from "./Mapping.vue?vue&type=script&lang=js"
import style0 from "./Mapping.vue?vue&type=style&index=0&id=49c6a0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6a0ae",
  null
  
)

export default component.exports